import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { IntlProvider } from 'react-intl';
import JssProvider from 'react-jss/lib/JssProvider';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import { create } from 'jss';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import client from '../lib/apolloClient';
import configureStore from '../store/findBobPublicStore';
import themes from '../lib/themes';
import getMessages from '../lib/i18n/getMessages';
import SuccessionDashboard from '../components/Succession/SuccessionDashboard';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import { CurrencyProvider } from '../hooks/useCurrency';

const SuccessionDashboardContainer = (props, railsContext) => {
  // Transform props to match reducer structure
  const initialState = {
    company: props.company || { 
      host: railsContext.company_host,
      features: railsContext.features,
      file_import_disclaimer: railsContext.file_import_disclaimer,
      name: railsContext.company_name,
      branded_name: railsContext.company_branded_name,
      short_name: railsContext.company_short_name,
    },
    user: props.current_user,
    intl: {
      locale: railsContext.i18nLocale || 'en'
    }
  };

  const store = configureStore(initialState);

  const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: true,
    productionPrefix: 'fbSuccession',
  });

  const jss = create({
    ...jssPreset(),
  });

  const theme = themes[railsContext.theme_name];
  window.locale = railsContext.i18nLocale || 'en';
  window.currency = railsContext.currency;

  return (
    <CurrencyProvider currency={railsContext.currency || 'USD'}>
      <IntlProvider locale={window.locale || 'en'} messages={getMessages(window.locale || 'en')}>
        <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="fbSuccession-">
          <MuiThemeProvider theme={createMuiTheme(theme)}>
            <CssBaseline />
            <Provider store={store}>
              <SnackbarProvider maxSnack={5}>
                <ApolloProvider client={client}>
                  <SuccessionThemeProvider
                    company={props.company || initialState.company}
                    user={props.current_user}
                  >
                    <SuccessionDashboard
                      {...props}
                    />
                  </SuccessionThemeProvider>
                </ApolloProvider>
              </SnackbarProvider>
            </Provider>
          </MuiThemeProvider>
        </JssProvider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default SuccessionDashboardContainer; 